import { render, staticRenderFns } from "./ReportSidebarSendReport.vue?vue&type=template&id=5497f248&"
import script from "./ReportSidebarSendReport.vue?vue&type=script&lang=js&"
export * from "./ReportSidebarSendReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports